import { h } from 'preact'
import classNames from 'clsx'

import styles from './index.module.scss'

const Aside = ({ className, children, ...props }) => (
  <aside
    className={buildClassName({ className })}
    {...props}
  >
    {children}
  </aside>
)

function buildClassName({ className }) {
  return classNames(
    className,
    styles['m-aside'],
  )
}


export default Aside
